var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-view-container",class:{ 'has-modal': _vm.hasModal }},[_vm._t("alert"),_vm._t("modal"),_c('div',{staticClass:"container"},[_c('div',{staticClass:"header"},[_vm._t("header")],2),_vm._t("content"),_vm._t("footer")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }